/**
 * Shared enter/exit actions for "Preview as <client>" (#115 P2).
 *
 * Note: the "Preview as a client" entry point was removed from the UI — it
 * conflicts with the clone-per-customer / tunnel model (you're inside one
 * company's instance, so "view as another company" doesn't apply). `exitClientPreview`
 * is still wired to the EnvironmentBanner's active "Previewing as X · Exit" state as a
 * safety hatch for any lingering preview; `enterClientPreview` is kept (dormant) in
 * case a per-prospect preview is reintroduced behind the internal surface later.
 */
import { useAppStore } from '@/store/appStore'
import { getDemoCompany } from '@/types/demoCompanies'
import { startPreviewClient, stopPreviewClient } from '@/config/previewClient'
import { markCompanyPicked } from '@/modules/timesheet/lib/companyPickIntent'

/** Enter preview for a client: flip the surface + switch the demo company to
 *  their org (if one matches the key) so data scopes to them. */
export function enterClientPreview(key: string): void {
  const prior = useAppStore.getState().currentCompanyId
  startPreviewClient(key, prior)
  if (getDemoCompany(key)) {
    markCompanyPicked(key)
    useAppStore.getState().setCurrentCompany(key)
  }
}

/** Exit preview: restore the cockpit + the demo company that was active before. */
export function exitClientPreview(): void {
  const restore = stopPreviewClient()
  markCompanyPicked(restore ?? null)
  useAppStore.getState().setCurrentCompany(restore ?? null)
}
